import React from 'react'

import './Content.scss'

export default ({ blue, children }) => (
  <article className={`content ${blue ? 'content--blue' : ''}`}>{children}</article>
)
